<template>
 <v-container fluid>
    <v-row align="center">
        <v-select
          :items="cities"
          label="City"
          @change="fetchApiData_restaurants()"
          v-model="CITY"
        ></v-select>
    </v-row>
    <v-row align="center">
        <v-select
            :items="restaurants"
            attach
            chips
            multiple
            label="Restaurants"
            v-model="restaurants_selected"
            @change="selectedRestaurants"
        ></v-select>
    </v-row>
  </v-container>
</template>


<script>

export default {
    name: 'cityselector',
    data() {
      return {
        cities: [],
        restaurants: [],
        restaurants_selected: [],
        CITY: ""
      }
    },
    methods: {
        selectedRestaurants () {            
            this.$emit("restaurants_selected", this.restaurants_selected);
            console.log("CHILD_ORG:", this.restaurants);
            console.log("CHILD:", this.restaurants_selected);
        },
        fetchApiData_cities() {
            console.log("Fetching data");
            var response, url;
            url = this.$store.state.api_url + "info/cities";
            console.log(url);
            fetch(url, {
                "method": "GET",
                "mode": "cors",
                "headers": {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                    var city_list = [];
                    for (var i in data) {
                      city_list.push(data[i]["CITY"]);
                    }
                    this.cities = city_list;
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });
        },
        fetchApiData_restaurants() {
                        // Test Vuex store
            this.$store.commit('increment');
            console.log("STORE:",this.$store.state.count);
            
            console.log("Fetching restaurants");
            var response, url;
            var city = this.CITY;
            this.$emit('CITY', city) // Emit city to the parent component
            city = city.toLowerCase();
            url = this.$store.state.api_url + "info/restaurants?city=" + city;
            console.log(url);
            fetch(url, {
                "method": "GET",
                "mode": "cors",
                "headers": {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            })
            .then(response => response.json()) 
            .then(data => { 
                if(data){
                    console.log(data);
                    // var city_list = [];
                    // for (var i in data) {
                    //   city_list.push(data[i]["CITY"]);
                    // }
                    this.restaurants = data;
                    this.$emit("restaurants", data); // Emit city to the parent component
                    this.restaurants_selected = this.restaurants;
                    this.selectedRestaurants();
                } else{
                    alert("Server returned " + response.status + " : " + response.statusText);
                }                
            })
            .catch(err => {
                console.log(err);
            });
        }
    },
    mounted() {
        this.fetchApiData_cities();
    }            
}
</script>



<style scoped>
p{
    font-size: 10px;
}
a {
    color: #0067a7 !important;
    text-decoration: none;
    font-size: 16px;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

th {
    border-bottom-width: 2px;
    vertical-align: top;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}


td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>